import { Component, OnInit, Inject, ViewChild, TemplateRef } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { GestockService } from '../services/gestock.service';



@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {


	@ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
	@ViewChild('messageDialog') messageDialog: TemplateRef<any>;


	messageRetour = "" ;


	montantrecu : any ;

    nbreligne = 0 ;

    paymean = "" ;

    noteCmd = "" ;

    numeropayment = "" ;

    infosclient = "" ;

    telephoneclient = "" ;

    adresseLivraison = "" ;

    nomServicePay = "" ;

    region = "" ;

    codeRetour = -1 ;

    idFacture : any ;

    codepartenaireInvalide = false ;
    
    tauxcomvendeur = 1 ;

    panier: any[] = [];
    allQtsOnCart: any[] = [];

    soustotal = 0 ;

    totalReduc = 0 ;

    appliable = true ;

   	dialogRefSpinner: any ;

   	dialogMessRef: any ;

    retourClientWS  : any ;

   	codevendeur : any ;

   	alreadyIn : Number[] = [] ;

   	removedArticle = [] ;

   	coutlivraison : any ;

	etape  = 0 ;


    clientIsParticulier = false ;

    leClient : any ;

	constructor( public dialog: MatDialog, public dialogRef: MatDialogRef<CartComponent>, 
				private configServer: GestockService, @Inject(MAT_DIALOG_DATA) public data: any) { 

		var currentPanier = localStorage.getItem("panier") ;

		var currentQtities =  localStorage.getItem("qteOnCart") ;

		this.codevendeur = data.codevendeur ;

		this.leClient = data.leClient ;

		if(this.codevendeur.length<3){
			console.log(this.codevendeur) ;
			this.clientIsParticulier = true ;		
		}else{
			this.numeropayment = "770000000" ;
		}

		console.log(currentPanier) ;

		console.log("Panier on Storage!!") ;
		console.log(currentPanier) ;
		if(currentPanier!=undefined && currentQtities!=undefined){
			this.panier = JSON.parse(currentPanier) ;
			this.allQtsOnCart = JSON.parse(currentQtities) ;
			this.nbreligne = this.panier.length ;
			for (var i = this.panier.length - 1; i >= 0; i--) {
				if(this.panier[i]==null)
					this.panier.splice(i,1) ;
				else
					this.soustotal = this.soustotal + Number(this.allQtsOnCart[i]) * Number(this.panier[i].prix) ;
			}
		}
		else
			this.panier = [] ;
  }



  nextStep(){
  	this.etape++ ;
  }

	previousStep(){
		if(this.etape==0)
			this.retourVersShop() ;
		else
	  	this.etape-- ;
	}


	telephoneValid(telephoneclient: any){
		if(this.telephoneclient.length==9 && !isNaN(this.telephoneclient as any) )
			return true;
		else
			return false ;
	}


	evaluerLivraison(){
		this.coutlivraison = 0 ;
	}


	checkCode(){
  	  	this.codepartenaireInvalide = false ;
	}

	validLength(){
		if(this.codevendeur.length==6 && !isNaN(this.codevendeur as any) )
			return true;
		else
			return false ;
	}

	UpdatePricingPart(){

		var currentPanier = localStorage.getItem("panier") ;
		var currentQtities =  localStorage.getItem("qteOnCart") ;

		if(currentPanier!=undefined && currentQtities!=undefined){
			this.panier = JSON.parse(currentPanier) ;
			this.allQtsOnCart = JSON.parse(currentQtities) ;
			this.nbreligne = this.panier.length ;
			for (var i = this.panier.length - 1; i >= 0; i--) {
				if(this.panier[i]==null)
					this.panier.splice(i,1) ;
				else{

					this.totalReduc = this.totalReduc + this.tauxcomvendeur*this.panier[i].comvendeur* this.allQtsOnCart[i] ;

					this.appliable = false ;
				}
			}
		}
		else
			this.panier = [] ;
	}



  hasValidNumPay(){

  	if(this.clientIsParticulier==false)
  		return true ;
  	else{
	  	if(this.numeropayment.length==9 && !isNaN(this.numeropayment as any) )
	  		return true ;
	  	else
	  		return false ;  		
  	}

  }



  ngOnInit(): void {
  }

  formatMoney(montant: any){
	let dollarUSLocale = Intl.NumberFormat('fr-FR');
	return dollarUSLocale.format(montant) ;
  }


  retourVersShop(){
    this.dialogRef.close( JSON.stringify(this.removedArticle) );    
  }


  removeFromCart(idarticleBi: any){
  	
  	this.removedArticle.push(idarticleBi) ;

	for (var i = 0; i < this.panier.length ; i++) {
		if (idarticleBi==i) {
			this.soustotal = 0 ;
			for (var j = 0; j < this.panier.length ; j++) {
				this.soustotal = this.soustotal + Number(this.allQtsOnCart[j]) * Number(this.panier[j].prix) ;
			}

			this.panier.splice(i, 1);
			this.allQtsOnCart.splice(i, 1);

			this.nbreligne = this.panier.length ;

			localStorage.setItem("panier", JSON.stringify(this.panier) ) ;
			localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;

			//var currentPanier = localStorage.getItem("panier") ;
			/*if(currentPanier==undefined){
				this.panier = [] ;
			}*/				
		}
	}
  }

  reinitialiser(){
	localStorage.removeItem("panier") ;
	localStorage.removeItem("qteOnCart") ;		
	this.panier = [] ;
	this.allQtsOnCart = [] ;
	this.nbreligne =  0;
	this.soustotal = 0 ;
	this.leClient = undefined ;
	this.etape = 0;
  }



  minus(j: any){
  	if(this.allQtsOnCart[j]>1){
	  	this.allQtsOnCart[j] = this.allQtsOnCart[j] - 1 ; 
		localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;
  	}

	localStorage.setItem("panier", JSON.stringify(this.panier) ) ;
	localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;

	var currentPanier = localStorage.getItem("panier") ;
	console.log("Panier on Storage!!") ;
	console.log(currentPanier) ;
	if(currentPanier!=undefined){
		this.panier = JSON.parse(currentPanier) ;
		this.nbreligne = this.panier.length ;
		this.soustotal = 0 ;
		for (var i = this.panier.length - 1; i >= 0; i--) {

			if( this.NestPlusElligible(Number(this.allQtsOnCart[i]), this.panier[i], i) ){
				for (var k = 0; k< this.alreadyIn.length;  k++) {
					if(this.alreadyIn[k]==i)
						this.alreadyIn.splice(k, 1) ;
				}

				console.log( this.panier[i].resturnrule) ;
				console.log( JSON.parse(this.panier[i].resturnrule)) ;

				//this.panier[i].prix = this.panier[i].prix + this.tauxcomvendeur*this.panier[i].comvendeur;
				//this.allQtsOnCart[i] = this.allQtsOnCart[i] + JSON.parse(this.panier[i].resturnrule).nbreArtOfrt ;

			}

			this.soustotal = this.soustotal + Number(this.allQtsOnCart[i]) * Number(this.panier[i].prix) ;
		}
	}
	else
		this.panier = [] ;


  }

  plus(j: any){

  	if(this.allQtsOnCart[j]>0){
	  	this.allQtsOnCart[j] = this.allQtsOnCart[j] + 1 ;
		localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;
  	}

	localStorage.setItem("panier", JSON.stringify(this.panier) ) ;
	localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;

	var currentPanier = localStorage.getItem("panier") ;
	console.log("Panier on Storage!!") ;
	console.log(currentPanier) ;
	if(currentPanier!=undefined){
		this.panier = JSON.parse(currentPanier) ;
		this.nbreligne = this.panier.length ;
		this.soustotal = 0 ;
		for (var i = this.panier.length - 1; i >= 0; i--) {

			if(this.estElligible(Number(this.allQtsOnCart[i]), this.panier[i], i) ){
				//this.panier[i].prix = this.panier[i].prix - this.tauxcomvendeur*this.panier[i].comvendeur;
				console.log( this.panier[i].resturnrule) ;
				console.log( JSON.parse(this.panier[i].resturnrule)) ;
				//this.allQtsOnCart[i] = this.allQtsOnCart[i] + Number(JSON.parse(this.panier[i].resturnrule).nbreArtOfrt) ;
			}
			
			this.soustotal = this.soustotal + Number(this.allQtsOnCart[i]) * Number(this.panier[i].prix) ;
		}
	}
	else
		this.panier = [] ;

  }


onQuantityUpdte(){


	console.log("Changing The Qty Input ") ;

	
	localStorage.setItem("panier", JSON.stringify(this.panier) ) ;
	localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;

	var currentPanier = localStorage.getItem("panier") ;
	console.log("Panier on Storage!!") ;
	console.log(currentPanier) ;
	if(currentPanier!=undefined){
		this.panier = JSON.parse(currentPanier) ;
		this.nbreligne = this.panier.length ;
		this.soustotal = 0 ;
		for (var i = this.panier.length - 1; i >= 0; i--) {

			if(this.estElligible(Number(this.allQtsOnCart[i]), this.panier[i], i) ){
				console.log( this.panier[i].resturnrule) ;
				console.log( JSON.parse(this.panier[i].resturnrule)) ;
				//this.panier[i].prix = this.panier[i].prix - this.tauxcomvendeur*this.panier[i].comvendeur;
				//this.allQtsOnCart[i] = this.allQtsOnCart[i] + Number(JSON.parse(this.panier[i].resturnrule).nbreArtOfrt) ;
			}else{
				if( this.NestPlusElligible(Number(this.allQtsOnCart[i]), this.panier[i], i) ){
					for (var k = 0; k< this.alreadyIn.length;  k++) {
						if(this.alreadyIn[k]==i)
							this.alreadyIn.splice(k, 1) ;
					}

					console.log( this.panier[i].resturnrule) ;
					console.log( JSON.parse(this.panier[i].resturnrule)) ;
					//this.panier[i].prix = this.panier[i].prix + this.tauxcomvendeur*this.panier[i].comvendeur;
					//this.allQtsOnCart[i] = this.allQtsOnCart[i] + JSON.parse(this.panier[i].resturnrule).nbreArtOfrt ;
				}

			}

			
			this.soustotal = this.soustotal + Number(this.allQtsOnCart[i]) * Number(this.panier[i].prix) ;
		}
	}
	else
		this.panier = [] ;
			
}


  retrieveInfoFromPaiement(event){
  	console.log("The Event is Triggered !") ;
    if(event!=0){
    	this.montantrecu = undefined ;
    	this.idFacture = event ;
    	this.montantrecu = sessionStorage.getItem("montantrecu");
    	this.etape++ ;

    }
  }





  estElligible(qte : Number, panierElt : any, index : Number){
  	
  	if(  Number(panierElt.seuilart)== qte && !this.alreadyIn.includes(index)) {
  		this.alreadyIn.push(index) ;
  		return true ;
  	}else
  		return false ;
  }


  NestPlusElligible(qte : Number, panierElt : any, index : Number){
  	
  	if(  Number(panierElt.seuilart)> qte && this.alreadyIn.includes(index)) {
  		return true ;
  	}else
  		return false ;
  }


  commanderPanier(){
	  
	this.dialogRefSpinner = this.openSpinnerDialog() ;

	console.log(this.codevendeur) ;
	console.log(this.paymean) ;

	/*this.configServer.commanderPanier("crypto.SHA1(this.codevendeur).toString(crypto.enc.Hex)",  this.panier, this.allQtsOnCart, this.paymean).then( (retourbi) => {
		  this.retourClientWS = retourbi ;	
		  console.log(retourbi) ;

		  this.messageRetour = this.retourClientWS.message ;

		  this.messageRetour = this.retourClientWS.message ;
		  this.codeRetour = this.retourClientWS.statutreq ;

		  this.dialogRefSpinner.close() ;

			if(this.retourClientWS.statutreq==1){
			  localStorage.setItem("panier", "[]") ;
			  localStorage.setItem("qteOnCart", "[]") ;			
			}

		  localStorage.setItem("panier", "[]") ;
		  localStorage.setItem("qteOnCart", "[]") ;

      	  this.openMessageDialog() ;
	}) ;*/
  }


validateQuantity(article, i) {
  const min = 1;
  const max = article.quantity.qteTotal;
  if (this.allQtsOnCart[i] < min) {
    this.allQtsOnCart[i] = min;
  } else if (this.allQtsOnCart[i] > max) {
    this.allQtsOnCart[i] = max;
  }
}

	trackByFn(index: any, item: any) {
	  return index;  
	}



  closeCommandeProcess(event){
	this.reinitialiser() ;
	this.dialogRef.close(11) ;
  }
 
  openSpinnerDialog() {
	return this.dialog.open(this.spinnerDialog);
  }

	openMessageDialog() {
		this.dialogMessRef = this.dialog.open(this.messageDialog);
		this.dialogMessRef.afterClosed().subscribe( (result: any) => {
			console.log("Messager Post Close Process") ;
		  this.retourVersShop() ;
		});
	}

	closeMessageDialog(){
		console.log("Closing Messager") ;
		this.dialogMessRef.close() ;
	}


}
